// src/pages/MiniReportsPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Nav from './Nav.js';
import './MiniReportsPage.css'; // Assuming you have a CSS file for styling

const reports = [
  {
    type: "daily-personal-horoscope",
    title: "Daily Personal Horoscope",
    description: "Know your daily astrological rhythm with muhurta, Rahu Kaal & remedies",
    icon: "https://img.icons8.com/emoji/48/sun-emoji.png",
  },
  {
    type: "love-compatibility",
    title: "Love Compatibility",
    description: "Check how well your stars align with your partner ❤️🔗",
    icon: "https://img.icons8.com/emoji/48/red-heart.png",
  },
  {
    type: "career-forecast",
    title: "Career Growth Forecast",
    description: "Unlock your career phase, timing and dos & don’ts 🚀💼",
    icon: "./launch.png",
  },
  {
    type: "financial-outlook",
    title: "Financial Outlook",
    description: "Get insights into wealth timing, savings & risks 💰📉",
    icon: "./money-bag.png",
  },
  {
    type: "marriage-timing",
    title: "Marriage Timing & Chances",
    description: "Find out when you might get married & how strong the promise is 💍📅",
    icon: "./wedding-ring.png",
  },
  {
    type: "health-wellness",
    title: "Health & Wellness",
    description: "Reveal your body’s strengths and upcoming health zones 🩺🌿",
    icon: "./healthcare.png",
  },
  {
    type: "childbirth-predictions",
    title: "Childbirth Predictions",
    description: "Check fertility timing and your future parenting vibes 👶🙏",
    icon: "./baby-boy.png",
  },
  {
    type: "job-vs-business",
    title: "Job vs Business Report",
    description: "Not sure what’s right? Let your stars decide 🧭🏢📈",
    icon: "./business.png",
  },
  {
    type: "personality-report",
    title: "Personality Deep-Dive",
    description: "Decode your mind, emotions and karmic blueprint 🧠🌌",
    icon: "./thinking.png",
  },
  {
    type: "planetary-transits",
    title: "Transit Impact Report",
    description: "See how current planetary shifts are affecting your life 🔄🪐",
    icon: "./planets.png",
  },
];

const MiniReportsPage = () => {
  const navigate = useNavigate();  
  return (
    <div>
    <Nav />
    <div className="mini-reports-container">
      <h1 className="mini-reports-title">📝 
        Your Mini Reports</h1>
      <div className="mini-reports-grid">
        {reports.map((report, index) => (
          <div className="mini-report-card" key={index} onClick={() => navigate(`/mini-report?type=${report.type}`)}
          style={{ cursor: 'pointer' }}>
            <div className="mini-report-content">
              <img src={report.icon} alt={report.title} className="mini-report-icon" />
              <div className="mini-report-text">
                <h2 className="mini-report-title">{report.title}</h2>
                <p className="mini-report-description">{report.description}</p>
              </div>
            </div>
          </div>
        
        ))}
      </div>
    </div>
    </div>
  );
};

export default MiniReportsPage;
